// extracted by mini-css-extract-plugin
export default {"button":"styles_button__VjwLv","card":"styles_card__il3Hw","bg":"styles_bg__d8xaW","iconContainer":"styles_iconContainer__-4BMa","icon":"styles_icon__1f0J0"};